<template>
    <grid-card
        :key-expr="keyExpr"
        :cardName="cardName"
        :empty-card-name="emptyCardName"
        :view-name="viewName"
        :api="apiGetList"
        :toolbar-meta="toolbarMeta"
        :selection-mode="selectionMode"
        :context-menu-meta="contextMenuMeta"
        :custom-context-menu="customContextMenu"
        ref="gridInstance"
        :store-args="storeArgs"
        :init-meta-data="initMetaData"
        :toolbar-show="toolbarShow"
        :filterPanelShow="filterPanelShow"
        :total-count-selected-show="totalCountSelectedShow"
        :filter-row="filterRow"
    >
        <template v-for="(_, slot) in $slots" #[slot]>
            <slot :name="slot" />
        </template>
    </grid-card>
</template>

<script>
export default {
    name: 'reg-grid',
};
</script>

<script setup>
import { ref, defineProps, onMounted, watch } from 'vue';
// import { gridCardStore } from '@/components/grid-card-component/grid-card-store';
import GridCard from '@/components/grid-card-component/grid-card.vue';

onMounted(async () => {});

const props = defineProps({
    dbSchema: String,
    dbSource: String,
    keyExpr: String,
    apiGetList: String,
    viewName: String,
    emptyCardName: String,
    cardName: String,
    selectionMode: String,
    toolbarMeta: Object,
    contextMenuMeta: Array,
    customContextMenu: Array,
    initMetaData: {
        type: Boolean,
        default: true,
    },
    totalCountSelectedShow: {
        type: Boolean,
        default: true,
    },
    toolbarShow: {
        type: Boolean,
        default: true,
    },
    filterPanelShow: {
        type: Boolean,
        default: true,
    },
    filterRow: {
        type: Object,
        default: () => {
            return { visible: true };
        },
    },
    findText: {
        type: String,
        default: () => {
            return '';
        },
    },
});
watch(
    () => props.findText,
    () => {
        gridInstance.value.gridInstance.searchByText(props.findText);
    }
);
const storeArgs = {
    db_schema_name: props.dbSchema,
    db_view_name: props.dbSource,
    key: props.keyExpr,
    api: `meta./${props.apiGetList}`,
};
// const listStore = gridCardStore(storeArgs, storeArgs.api);
const gridInstance = ref(null);

defineExpose({
    gridInstance,
});
</script>
<style>
#ai-reg-grid {
    height: 100%;
}
</style>
